import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const packageBaseEndpoint = ENDPOINTS.PACKAGETYPE;

// Package Type API
export const packageTypeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["packageType"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPackageType: builder.query({
        query: (payload) => `${packageBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "packageType" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addPackageType: builder.mutation({
        query: (requestData) => ({
          url: `${packageBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "packageType" }],
      }),
      updatePackageType: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${packageBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "packageType" }],
      }),
      deletePackageType: builder.mutation({
        query: (id) => ({
          url: `${packageBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "packageType" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetPackageTypeQuery,
  useAddPackageTypeMutation,
  useUpdatePackageTypeMutation,
  useDeletePackageTypeMutation,
} = packageTypeApi;
